import { render, staticRenderFns } from "./NewAllCompaniesView.vue?vue&type=template&id=8d4cd5f0&scoped=true"
import script from "./NewAllCompaniesView.vue?vue&type=script&lang=js"
export * from "./NewAllCompaniesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4cd5f0",
  null
  
)

export default component.exports